

























import Vue from "vue";
export default class Bottom extends Vue {}
